var _process$env;
// eslint-disable-next-line
var hostname;
var _protocol = '';
var globalConfig = {};
if (typeof window !== 'undefined') {
  hostname = window.location.hostname;
  _protocol = window.location.protocol;
  // eslint-disable-next-line
  globalConfig = window.__BYBIT_GLOBAL_CONFIG__ || {};
}
// 运行环境根据域名判断

export var isProdOrTestnet = /^[^.]+\.[^.]+\.[^.]+$/.test(hostname) || /^[^.]+\.[^.]+\.[^.]+\.(hk|uae|us|uk|jp|fr|de|au|ca|br|in|ru)$/.test(hostname);
export var isTestnet = isProdOrTestnet && /^[^.]*testnet[^.]*\./.test(hostname);
export var isProd = isProdOrTestnet && !isTestnet;
export var isTest = !isTestnet && !isProd;
export var isDev = isTest;
export var isSSL = _protocol === 'https:';
export var protocol = _protocol;

/* (START) Just for Automan
  以下代码与业务template 以及 automan功能脚本注入 联动，关联性暂时依赖人为维护，可维护性待升级
*/
// eslint-disable-next-line no-underscore-dangle
var ac = globalConfig.enableAutoman && globalConfig.automan || {};
export var ENV_RUNTIME_ENV = ac.AUTOMAN_RUNTIME_ENV;
// 接口相关
export var ENV_API2_HOST = ac.AUTOMAN_API2_HOST;
export var ENV_WS2_HOST = ac.AUTOMAN_WS2_HOST;
// 翻译
export var ENV_TMS_HOST = ac.AUTOMAN_TMS_HOST;
export var ENV_TMS_PATH = ac.AUTOMAN_TMS_PATH;
export var ENV_TMS_FULL_PATH = ac.AUTOMAN_TMS_FULL_PATH;
// 线路切换
export var ENV_SERVICE_DOMAINS = ac.AUTOMAN_SERVICE_DOMAINS;

// apm
export var ENV_APM_ENABLED = ac.AUTOMAN_APM_ENABLED;
export var ENV_APM_URL = ac.AUTOMAN_APM_URL;
// sentry
export var ENV_SENTRY_ENABLED = ac.AUTOMAN_SENTRY_ENABLED;
export var ENV_SENTRY_DSN = ac.AUTOMAN_SENTRY_DSN;
// Logger
export var ENV_LOGGER_ENABLED = ac.AUTOMAN_LOGGER_ENABLED;
export var ENV_LOGGER_URL = ac.AUTOMAN_LOGGER_URL;
// Metric
export var ENV_METRIC_URL = ac.AUTOMAN_METRIC_URL;
export var ENV_METRIC_ENABLED = ac.AUTOMAN_METRIC_ENABLED;
// sensors
export var ENV_SENSORS_URL = ac.AUTOMAN_SENSORS_URL;
export var ENV_SENSORS_ENABLED = ac.AUTOMAN_SENSORS_ENABLED;
/* 以上代码与业务template 以及 automan功能脚本注入 联动，关联性暂时依赖人为维护，可维护性待升级
  (END) Just for Automan
*/

// runtime env 代替原来jenkins中的构建常量BUILD_ENV
var runtimeEnv = 'local';
if (isTestnet) {
  runtimeEnv = 'testnet';
} else if (isProd) {
  runtimeEnv = 'prod';
} else if (isTest) {
  runtimeEnv = 'test';
}
export var RUNTIME_ENV = ENV_RUNTIME_ENV || runtimeEnv;

// 翻译系统
var tmsHost = isTest ? 'https://tms.ffe390afd658c19dcbf707e0597b846d.de' : '';
export var TMS_HOST = process.env.BYBIT_TMS_HOST || ENV_TMS_HOST || tmsHost;
var tmsPath = isTest ? '/download/{{projectId}}/{{ns}}/{{lng}}/' : '/translations/{{projectId}}/{{lng}}/{{ns}}.json';
export var TMS_PATH = process.env.BYBIT_I18N_SOURCE_URL || ENV_TMS_PATH || tmsPath;
export var TMS_FULL_PATH = ENV_TMS_FULL_PATH || "".concat(TMS_HOST).concat(TMS_PATH);

// 线路切换
var serviceDomains = '';
if (isTestnet) {
  serviceDomains = 'bybitglobal.com';
} else if (isProd) {
  serviceDomains = 'bycbe.com, byapis.com';
} else if (isTest) {
  serviceDomains = 'bybit-cn.com';
}
export var BYBIT_SERVICE_DOMAINS = process.env.BYBIT_SERVICE_DOMAINS || ENV_SERVICE_DOMAINS || serviceDomains;

/* skynet begin */
// APM
var apmUrl = isProd && 'https://apm.ffbbbdc6d3c353211fe2ba39c9f744cd.com' || isTestnet && 'https://apm-testnet.ffbbbdc6d3c353211fe2ba39c9f744cd.com' || '';
export var APM_URL = process.env.BYBIT_APM_URL || ENV_APM_URL || apmUrl;
var apmDisabled = process.env.BYBIT_APM_DISABLED === 'true';
export var APM_ENABLED = process.env.BYBIT_APM_DISABLED || !apmDisabled;

// Sentry
export var SENTRY_DSN = process.env.BYBIT_SENTRY_DSN || ENV_SENTRY_DSN;
var sentryDisabled = process.env.BYBIT_SENTRY_DISABLED === 'true';
export var SENTRY_ENABLED = ENV_SENTRY_ENABLED || !sentryDisabled;

// Logger
var logger_url = isProd ? 'https://api.ffbbbdc6d3c353211fe2ba39c9f744cd.com/p/front' : 'https://api.ffbbbdc6d3c353211fe2ba39c9f744cd.com/p/front-testnet';
export var LOGGER_URL = process.env.BYBIT_LOGGER_URL || ENV_LOGGER_URL || logger_url;
var loggerDisabled = process.env.BYBIT_LOGGER_DISABLED === 'true';
export var LOGGER_ENABLED = ENV_LOGGER_ENABLED || !loggerDisabled;

// Metric
export var METRIC_URL = process.env.BYBIT_METRIC_URL || ENV_METRIC_URL || '/v2/public/metrics';
var metricDisabled = process.env.BYBIT_METRIC_DISABLED === 'true';
export var METRIC_ENABLED = ENV_METRIC_ENABLED || !metricDisabled;
/* skynet end */

export var sensors_url = isProd ? 'https://sc-datasink.ffe390afd658c19dcbf707e0597b846d.de/sa?project=production' : 'https://sc-datasink.ffe390afd658c19dcbf707e0597b846d.de/sa?project=default';
export var SENSORS_URL = process.env.BYBIT_SENSORS_URL || ENV_SENSORS_URL || sensors_url;
var sensorsDisabled = process.env.BYBIT_SENSORS_DISABLED === 'true';
export var SENSORS_ENABLED = ENV_SENSORS_ENABLED || !sensorsDisabled;

// cloud域和announcement域下获取静态资源的host
// eslint-disable-next-line import/no-mutable-exports
var repaired_hostname = hostname;
var whiteList = ['cloud', 'announcements', 'sandbox', 'blog', 'newblog', 'learn'];
if (hostname && whiteList.some(function (host) {
  return hostname.includes(host);
})) {
  var testnetReg = new RegExp("(?:(?:".concat(whiteList.join('|'), ")-testnet|testnet-(?:").concat(whiteList.join('|'), "))"), 'g');
  var mainnetReg = new RegExp("^(?:".concat(whiteList.join('|'), ")(?=.)"), 'g');
  repaired_hostname = hostname.replace(testnetReg, 'testnet').replace(mainnetReg, 'www');
}
export { repaired_hostname };

/**
 * 获取当前所处站点，返回字符串
 * HKG：香港站
 * BYBIT：全球站
 * ARE: 阿联酋站
 * NLD: 荷兰站
 * TUR: 土耳其站
 * KAZ: 哈萨克斯站
 * EU: 欧洲站
 */
export var REGULATED_SITE_HOSTS = function (_hostname, _hostname2, _hostname3, _hostname4) {
  if ((_hostname = hostname) === null || _hostname === void 0 ? void 0 : _hostname.includes('bybit.eu')) {
    return 'EU';
  }
  if ((_hostname2 = hostname) === null || _hostname2 === void 0 ? void 0 : _hostname2.includes('bybit.kz')) {
    return 'KAZ';
  }
  if ((_hostname3 = hostname) === null || _hostname3 === void 0 ? void 0 : _hostname3.includes('bybit-tr.com')) {
    return 'TUR';
  }
  if (/^[^.]+\.[^.]+\.[^.]+\.hk$/.test(hostname) || /^[^.]+\.[^.]+\.[^.]+\.[^.]+\.hk$/.test(hostname) || ((_hostname4 = hostname) === null || _hostname4 === void 0 ? void 0 : _hostname4.includes('byhkbit.com'))) {
    return 'HKG';
  }
  if (/^[^.]+\.[^.]+\.ae$/.test(hostname) || /^[^.]+\.[^.]+\.[^.]+\.ae$/.test(hostname)) {
    return 'ARE';
  }
  if (/^[^.]+\.[^.]+\.nl$/.test(hostname) || /^[^.]+\.[^.]+\.[^.]+\.nl$/.test(hostname)) {
    return 'NLD';
  }
  return 'BYBIT';
}();
export var isBrowser = typeof window !== 'undefined';

/**
 * @returns true if the current environment is bybit app
 */
export var isBybitApp = function isBybitApp() {
  if (isBrowser) {
    return /bybit_app/.test(navigator.userAgent.toLowerCase());
  }
  return false;
};

/**
 * 判断当前环境是否是 bybit app TR
 */
export var isBybitTrApp = function isBybitTrApp() {
  if (isBrowser) {
    return /bybit_app_tr/.test(navigator.userAgent.toLowerCase());
  }
  return false;
};

/**
 * 判断当前环境是否是 bybit app EU
 */
export var isBybitEuApp = function isBybitEuApp() {
  if (isBrowser) {
    return /bybit_app_eu/.test(navigator.userAgent.toLowerCase());
  }
  return false;
};
var h5OsList = ['android', 'ios'];
export function isMobile() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|Telegram-Android/i;
  var tabletRE = /android|ipad|playbook|silk/i;
  var ua = opts === null || opts === void 0 ? void 0 : opts.ua;
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent'];
  }
  if (typeof ua !== 'string') return false;
  var result = mobileRE.test(ua) || !!opts.tablet && tabletRE.test(ua);
  if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) {
    result = true;
  }
  return result;
}
/**
 * 判断是否是tg小程序里边
 */
export function isTGMiniApp() {
  if (typeof window !== 'undefined') {
    var _window;
    return !!((_window = window) === null || _window === void 0 ? void 0 : _window.TelegramWebviewProxy);
  }
  return false;
}
export var TG_PLATFORM = {
  PC: 'pc_tg',
  IOS: 'ios_tg',
  ANDROID: 'android_tg'
};
function getOS() {
  var _window2, _window2$navigator, _window3, _window3$navigator;
  var userAgent = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$navigator = _window2.navigator) === null || _window2$navigator === void 0 ? void 0 : _window2$navigator.userAgent) || '';
  var platform = ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$navigator = _window3.navigator) === null || _window3$navigator === void 0 ? void 0 : _window3$navigator.platform) || '';
  var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  var iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  var os = null;
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'macos';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'ios';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'windows';
  } else if (/Android/.test(userAgent)) {
    os = 'android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'linux';
  }
  return os;
}
/**
* 传入参数为现有的platform的取值参数, 比如uniframe默认写死的pc
*/
export var getPlatform = function getPlatform(platfrom) {
  try {
    if (isBrowser) {
      if (isTGMiniApp()) {
        var currentSystem = getOS();
        if (currentSystem && h5OsList.includes(currentSystem)) {
          return currentSystem === 'ios' ? TG_PLATFORM.IOS : TG_PLATFORM.ANDROID;
        }
        return TG_PLATFORM.PC;
      }
      return platfrom !== null && platfrom !== void 0 ? platfrom : isMobile() ? 'h5' : 'pc';
    }
    return platfrom !== null && platfrom !== void 0 ? platfrom : isMobile() ? 'h5' : 'pc';
  } catch (e) {
    return platfrom !== null && platfrom !== void 0 ? platfrom : isMobile() ? 'h5' : 'pc';
  }
};
export var getXUserAgent = function getXUserAgent() {
  try {
    if (isBrowser) {
      if (!isTGMiniApp()) {
        return undefined;
      }
      // xuaPC:= "company/bybit platform/tg-mini system/windows device/pc"
      // xuaPhone:= "company/bybit platform/tg-mini system/android device/phone"
      var currentSystem = getOS() || (!isMobile() ? 'windows' : 'android');
      var device = !h5OsList.includes(currentSystem) ? 'pc' : 'phone';
      return "company/bybit platform/tg-mini system/".concat(currentSystem, " device/").concat(device);
    }
    return undefined;
  } catch (e) {
    return undefined;
  }
};
export var platform = getPlatform();
export var xUserPlatform = getXUserAgent();
export var s3TransformPath = new Map([
// 前台bucket
['https://fh-static.bycsi.com', '/common-static/fhs'],
// 中台法币期货testnet bucket
['https://t1.bycsi.com', '/bycsi-root'],
// 中台法币期货mainnet bucket
['https://s1.bycsi.com', '/bycsi-root']]);
export var isLocal = typeof process !== 'undefined' && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === 'development';
export function getRelativeUrl(url) {
  var isDEV = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  try {
    var urlObj = new URL(url);
    if (!s3TransformPath.has(urlObj.origin)) return url;
    var result = url;
    result = url.replace(urlObj.origin, s3TransformPath.get(urlObj.origin));
    if (isLocal || isDEV) {
      // t1.bycsi.com的用testnet.bybit.com
      if (urlObj.origin.includes('t1.bycsi.com')) {
        result = "https://testnet.bybit.com".concat(result);
      } else {
        result = "https://www.bybit.com".concat(result);
      }
    }
    return result;
  } catch (error) {
    return url;
  }
}